<template>
	<div class="policyItem">
		<div class="project">
			<div v-for="(item,index) of list" :key="index" class="li" @click="policyDe(item.id)">
				<div class="name">
					{{item.title}}
				</div>
				<div class="lis">
					<img src="@/static/timeIcon.png" class="icon" />
					<div>
						{{item.application_start_date.split(' ')[0]}}-{{item.application_end_date.split(' ')[0]}}
					</div>
				</div>
				<div v-if="item.company" class="lis">
					<img src="@/static/corIcon.png" class="icon" />
					<div>
						{{item.company.simple_name}}
					</div>
				</div>
				<div class="button">
					申报
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['list'],
		data() {
			return {
				
			}
		},
		created() {

		},
		methods: {
			policyDe(id){
				this.$router.push({ name: 'policyDe',query:{id:id}});
			}
		}
	}
</script>

<style lang="scss">
	.project {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		// margin-bottom: 48px;
	
		.li {
			position: relative;
			width: 390px;
			margin-right: 15px;
			margin-bottom: 16px;
			cursor: pointer;
			&:nth-child(3n) {
				margin-right: 0;
			}
	
			padding: 16px 22px;
			background-color: #FFF;
			border-radius: 8px;
			box-sizing: border-box;
	
			.name {
				color: #151515;
				font-size: 18px;
				font-weight: bold;
				margin-bottom: 14px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
	
			}
	
			.lis {
				display: flex;
				align-items: center;
				margin-bottom: 4px;
				font-size: 14px;
	
				&:last-child {
					margin-bottom: 0;
				}
	
				.icon {
					width: 15px;
					height: 15px;
					margin-right: 3px;
				}
			}
	
			.button {
				width: 58px;
				line-height: 28px;
				text-align: center;
				background-color: rgba(155, 108, 255, 0.1);
				border-radius: 8px;
				color: #9B6CFF;
				font-size: 13px;
				cursor: pointer;
				transition: all 0.2s;
				position: absolute;
				right: 22px;
				bottom: 16px;
	
				&:hover {
					background-color: rgba(155, 108, 255, 1);
					color: #fff;
				}
			}
		}
	}
</style>